import React, { useState } from 'react';

import {  Menu } from 'antd';
import { useRouteMatch } from 'react-router-dom';

import { DownOutlined } from '@ant-design/icons';

import SidebarLogo from './SidebarLogo';
import styles from './styles.module.less';
import MenuLabel from './components/MenuLabel';
import MenuIcon from './components/MenuIcon/index.js';

const WorkDirectionMenu = React.memo(() => {
  let { url } = useRouteMatch();

  const getItem = ({ label, key, icon, children, type, disabled }) => {
    return {
      key,
      icon,
      children,
      label,
      type,
      disabled,
    };
  };

  const items = [
    getItem({
      label: <MenuLabel idLabelMessage="general.home" to={url} />,
      key: 'home',
      icon: <MenuIcon iconName="home" />,
    }),
  ].filter(Boolean);

  return (
    <>
      <SidebarLogo />
      <div className={styles.content}>
        <Menu
          defaultSelectedKeys={['home']}
          mode="inline"
          theme="dark"
          items={items}
          className={styles.sideBarMenu}
          expandIcon={({ isOpen }) => <DownOutlined rotate={isOpen ? 180 : 0} />}
        />
      </div>
    </>
  );
});

export default WorkDirectionMenu;
